import { faXmark } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';

import { CloseContainerIconStyled } from './TrlCloseFeedbackIcon.styles';

export const TrlCloseFeedbackIcon = ({ onClick }) => (
  <CloseContainerIconStyled
    id="closeFeedbackIcon"
    icon={faXmark}
    onClick={onClick}
  />
);

TrlCloseFeedbackIcon.propTypes = {
  onClick: PropTypes.func.isRequired,
};
